import slugify from "@sindresorhus/slugify";
export const PROJECT_SLUG_MAX_LENGTH = 64;
const PROJECT_SLUG_FALLBACK = "project";
/**
 * Slugify an arbitrary user-supplied project name into a unix-safe folder name.
 * Transliterates non-Latin scripts (e.g. Cyrillic, Greek) and falls back to
 * "project" when the input slugifies to an empty string (e.g. emoji-only).
 */
export function slugifyProjectName(raw) {
    const slug = slugify(raw, { separator: "-", lowercase: true });
    const trimmed = slug.slice(0, PROJECT_SLUG_MAX_LENGTH).replace(/-+$/g, "");
    return trimmed.length > 0 ? trimmed : PROJECT_SLUG_FALLBACK;
}
